/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyRate
 */
export interface DailyRate {
    /**
     * 
     * @type {number}
     * @memberof DailyRate
     */
    price: number;
    /**
     * 
     * @type {boolean}
     * @memberof DailyRate
     */
    hidden: boolean;
}

/**
 * Check if a given object implements the DailyRate interface.
 */
export function instanceOfDailyRate(value: object): value is DailyRate {
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('hidden' in value) || value['hidden'] === undefined) return false;
    return true;
}

export function DailyRateFromJSON(json: any): DailyRate {
    return DailyRateFromJSONTyped(json, false);
}

export function DailyRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyRate {
    if (json == null) {
        return json;
    }
    return {
        
        'price': json['price'],
        'hidden': json['hidden'],
    };
}

export function DailyRateToJSON(value?: DailyRate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'price': value['price'],
        'hidden': value['hidden'],
    };
}

